<template>
  <div>
    <ed-alert
      class="mb-3"
      type="warning"
      title="Atenção"
      description="Aqui você visualizar o histórico de atendimento dessa consulta"
    />

    <TableView
      :onSearch="getConsultaAcompanhamento"
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableInputSearch
      disableCheckAll
      disabledConfigCell
    />
  </div>
</template>

<script>

import Rest from 'common/rest'
import EdAlert from 'common/alert'
import TableView from 'common/table'

export default {
    name: 'empresa.consulta.exame',
    components:{TableView,EdAlert},
    mixins:[Rest],
    data () {
      return{
        tableHead: [
          {
            key: 'created_at',
            sortable: true,
            width:'150px',
            label: 'Data',
          },
          {
            key: 'usuario',
            sortable: true,
            show_point:true,
            label: 'Usuario',
          },
          {
            key: 'tipo_status',
            sortable: true,
            width:'250px',
            label: 'Status',
          },
          {
            key: 'obs',
            sortable: true,
            label: 'Observações',
          },
        ],
        tableData: [],
        loadingTable: false,
        pagination:{},
        response:{},
      }
    },
    beforeDestroy(){
			this.tableData = [];
		},
    created(){
    },

    mounted(){
      this.getConsultaAcompanhamento();
    },

    computed: {
    },

    methods:{

      onEdit(data){

      },

      getConsultaAcompanhamento(search,page,pagination){

        this.loadingTable = true;
        this.response = {};

        this.get('consulta/externa/acompanhamento/'+this.$route.params.consulta,{search:search,page:page,pagination:pagination}).then((result) =>{
          result = result[0];

          this.loadingTable = false;
          this.response = result;

          var data = [], tableData = [], pagination = {};

          if(result.status == 200){
            
            data = result.data.data;
 
            for (var i = 0; i < data.length; i++) {

              var item = {
                id: data[i].id,
                created_at: this.toDate(data[i].created_at),
                usuario: (data[i].log_acesso && data[i].log_acesso.usuario ? data[i].log_acesso.usuario.usuario : null),
                tipo_status: (data[i].tipo_status ? data[i].tipo_status.descricao : null),
                obs: data[i].obs,
                _data: data[i],
                buttons : []
              };

              tableData.push(item);
            }

            pagination = result.data;
          }

          this.tableData = tableData;
          this.pagination = pagination;
        });
      }
    }
}
</script>
</style>



// WEBPACK FOOTER //
// index.vue?c25ae416